var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MarketSettingTask',{attrs:{"isMainLoading":_vm.isMainLoading,"marketId":_vm.marketId},on:{"onInitSettingTask":_vm.onInitSettingTask}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }